import apiSlice from "./ApiSlice";

const CategoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllCMSData: builder.query({
      providesTags: ["cms"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/cms",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteCMSById: builder.mutation({
      invalidatesTags: ["cms"],
      query: ({ type, id }) => ({
        url: `/cms/${type}/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addCMS: builder.mutation({
      invalidatesTags: ["cms"],
      query: (body) => ({
        url: `/cms/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getCMSByType: builder.query({
      providesTags: ["cms"],
      query: (type: string) => ({
        url: `/cms/${type}`,
        method: "GET",
      }),
    }),

    // update delivery date
    updateCMS: builder.mutation({
      invalidatesTags: ["cms"],
      query: ({ type, body }) => ({
        url: `/cms/${type}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllCMSDataQuery,
  useDeleteCMSByIdMutation,
  useAddCMSMutation,
  useGetCMSByTypeQuery,
  useUpdateCMSMutation,
} = CategoryApi;
